<template>
  <header class="header-member">
    <div class="container flex">
      <div class="logo">
        <template v-if="!isAuWallet()">
          <router-link class="-link" :to="{ name: 'mb001' }">
            <img
              src="@/assets/images/common/logo_main.gif"
              :alt="$t('common.sitename')"
              class="img-fluid"
              width="189"
            />
          </router-link>
        </template>
        <template v-else>
          <img
            src="@/assets/images/common/logo_main.gif"
            :alt="$t('common.sitename')"
            class="img-fluid"
            width="189"
          />
        </template>
      </div>
      <nav v-if="!isAuWallet()" class="header-nav">
        <div class="subnav-list">
          <!--<router-link v-if="isOverDue" class="-spnone" :to="{name: 'sv040'}" target="_blank">期限超過</router-link>-->
          <a
            href="https://qa.kddi-fs.com/?site_domain=loan"
            class="-spnone"
            target="_blank"
            ><span
              @click="
                trackGtmEvent('【click】ヘッダー', 'ヘッダー,よくあるご質問')
              "
              >よくあるご質問</span
            ></a
          >
          <router-link
            class="-spnone"
            :to="{ name: 'sv036' }"
            target="_blank"
            @click="trackGtmEvent('【click】ヘッダー', 'ヘッダー,お問い合わせ')"
            >お問い合わせ</router-link
          >
          <button
            class="logout"
            @click="
              logout();
              trackGtmEvent('【click】ヘッダー', 'ヘッダー,ログアウト');
            "
          >
            <span class="-logout">ログアウト</span>
          </button>
          <div class="-pcnone menu" @click.prevent="toggleMenu()">
            <a class="menu-trigger" :class="{ active: menuOpen }">
              <span></span>
              <span></span>
              <span></span>
            </a>
            <p class="menutxt">MENU</p>
          </div>
        </div>
        <div class="overlay" :class="{ show: menuOpen }"></div>
        <transition
          name="slide"
          @after-enter="afterEnter()"
          @before-leave="beforeLeave()"
        >
          <div
            v-show="menuOpen"
            class="-pcnone spmenu"
            :class="{ show: menuOpened }"
          >
            <AccordionList>
              <AccordionItem class="-heading -link" to="mb001"
                >トップページ</AccordionItem
              >
            </AccordionList>
            <AccordionList class="-disabled">
              <AccordionItem class="-title -orange" :title="true"
                >お借り入れ</AccordionItem
              >
              <template
                v-if="
                  isProhibitedDeposit ||
                  isProhibitedPrepaid ||
                  isProhibitedGelato ||
                  isProhibitedWakai
                "
              >
                <AccordionItem
                  class="-link -icon disabled"
                  src="mb-charge.svg"
                  @click="
                    trackGtmEvent(
                      '【click】グロナビ',
                      'グロナビ,お借り入れ,au PAYプリペイドカードにチャージ'
                    )
                  "
                  >au PAY 残高にチャージ</AccordionItem
                >
              </template>
              <template v-else>
                <AccordionItem
                  class="-link -icon"
                  to="mb012"
                  src="mb-charge.svg"
                  @click="
                    trackGtmEvent(
                      '【click】グロナビ',
                      'グロナビ,お借り入れ,au PAYプリペイドカードにチャージ'
                    )
                  "
                  >au PAY 残高にチャージ</AccordionItem
                >
              </template>

              <template v-if="isProhibitedDeposit || isProhibitedSeven || isProhibitedWakai">
                <AccordionItem
                  class="-link -icon disabled"
                  src="mb-seven.svg"
                  @click="
                    trackGtmEvent(
                      '【click】グロナビ',
                      'グロナビ,お借り入れ,セブン銀行スマホATM'
                    )
                  "
                  >セブン銀行スマホATM</AccordionItem
                >
              </template>
              <template v-else>
                <AccordionItem
                  class="-link -icon"
                  src="mb-seven.svg"
                  @click.prevent="
                    launchApp('loan');
                    trackGtmEvent(
                      '【click】グロナビ',
                      'グロナビ,お借り入れ,セブン銀行スマホATM'
                    );
                  "
                  >セブン銀行スマホATM</AccordionItem
                >
              </template>
              <template v-if="isProhibitedDeposit || isProhibitedSmbc || isProhibitedWakai">
                <AccordionItem
                  class="-link -icon disabled"
                  src="mb-bank.svg"
                  @click="
                    trackGtmEvent(
                      '【click】グロナビ',
                      'グロナビ,お借り入れ,ご登録口座へのお振込み'
                    )
                  "
                  >ご登録口座へのお振込み</AccordionItem
                >
              </template>
              <template v-else>
                <AccordionItem
                  class="-link -icon"
                  to="mb011"
                  src="mb-bank.svg"
                  @click="
                    trackGtmEvent(
                      '【click】グロナビ',
                      'グロナビ,お借り入れ,ご登録口座へのお振込み'
                    )
                  "
                  >ご登録口座へのお振込み</AccordionItem
                >
              </template>
              <!--<AccordionItem class="-link" to="sv036" target="_blank">増枠をご希望のお客さまはこちら</AccordionItem>-->
            </AccordionList>
            <AccordionList class="-disabled">
              <AccordionItem class="-title -green" :title="true"
                >ご返済</AccordionItem
              >
              <template v-if="isProhibitedWakai || isProhibitedSeven">
                <AccordionItem
                  class="-link -icon disabled"
                  src="mb-seven.svg"
                  @click="
                    trackGtmEvent(
                      '【click】グロナビ',
                      'グロナビ,ご返済,セブン銀行スマホATM'
                    )
                  "
                  >セブン銀行スマホATM</AccordionItem
                >
              </template>
              <template v-else>
                <AccordionItem
                  class="-link -icon"
                  src="mb-seven.svg"
                  @click.prevent="
                    launchApp('payback');
                    trackGtmEvent(
                      '【click】グロナビ',
                      'グロナビ,ご返済,セブン銀行スマホATM'
                    );
                  "
                  >セブン銀行スマホATM</AccordionItem
                >
              </template>
              <AccordionItem
                class="-link -icon"
                to="mb015"
                src="mb-pay.svg"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,ご返済,指定口座へのお振込み'
                  )
                "
                >指定口座へのお振込み</AccordionItem
              >
              <AccordionItem class="-link" to="mb052"
                >ご返済シミュレーション</AccordionItem
              >
            </AccordionList>
            <AccordionList>
              <AccordionItem class="-heading -toggle" :toggle="true"
                >ご契約・お取引情報</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="mb019"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,ご契約・お取引情報,ご契約内容のご確認'
                  )
                "
                >ご契約内容のご確認</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="mb004"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,ご契約・お取引情報,お取引履歴のご確認'
                  )
                "
                >お取引履歴のご確認</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="mb020"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,ご契約・お取引情報,ご契約締結書面一覧のご確認'
                  )
                "
                >ご契約締結書面一覧のご確認</AccordionItem
              >
            </AccordionList>
            <AccordionList>
              <AccordionItem class="-heading -toggle" :toggle="true"
                >お客さま情報</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="mb023"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,お客さま情報,お客さま情報の確認・変更'
                  )
                "
                >お客さま情報の確認・変更</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="mb021"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,お客さま情報,口座情報の登録・変更'
                  )
                "
                >口座情報の登録・変更</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="mb026"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,お客さま情報,メールアドレス・お知らせ通知設定の変更'
                  )
                "
                >メールアドレス・お知らせ通知設定の変更</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="mb032"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,お客さま情報,暗証番号再設定'
                  )
                "
                >暗証番号再設定</AccordionItem
              >
            </AccordionList>
            <div class="qa btn">
              <a
                href="https://qa.kddi-fs.com/?site_domain=loan"
                class="atag"
                target="_blank"
              >
                <span class="txt"
                  ><img
                    class="img"
                    src="@/assets/images/icons/menu-question.svg"
                    alt=""
                  />よくあるご質問</span
                >
              </a>
              <router-link class="atag" :to="{ name: 'sv036' }" target="_blank">
                <span class="txt"
                  ><img
                    class="img"
                    src="@/assets/images/icons/menu-contact.svg"
                    alt=""
                  />お問い合わせ</span
                >
              </router-link>
            </div>
            <div class="close btn">
              <a class="atag" href="" @click.prevent="toggleMenu()">
                <span class="txt"
                  ><img
                    class="img"
                    src="@/assets/images/icons/close-gray.svg"
                    alt=""
                  />閉じる</span
                >
              </a>
            </div>
          </div>
        </transition>
        <NavList class="-spnone">
          <NavItem to="mb001" :class="{ active: isMbTop() }" nav-name="mb-top"
            >トップページ</NavItem
          >
          <NavItem :class="{ active: isMbBorrow() }" nav-name="mb-borrow"
            >お借り入れ</NavItem
          >
          <NavItem :class="{ active: isMbReturn() }" nav-name="mb-return"
            >ご返済</NavItem
          >
          <NavItem :class="{ active: isMbLoan() }" nav-name="mb-loan"
            >ご契約・お取引情報</NavItem
          >
          <NavItem :class="{ active: isMbMypage() }" nav-name="mb-mypage"
            >お客さま情報</NavItem
          >
        </NavList>
        <DrawerList to="mb011" nav-name="mb-borrow" class="-grid-2">
          <template
            v-if="
              isProhibitedDeposit || isProhibitedPrepaid || isProhibitedGelato || isProhibitedWakai
            "
          >
            <DrawerItem
              src="mb-charge.svg"
              class="-double disabled"
              disabled="disabled"
              @click="
                trackGtmEvent(
                  '【click】グロナビ',
                  'グロナビ,お借り入れ,au PAYプリペイドカードにチャージ'
                )
              "
              >au PAY 残高にチャージ</DrawerItem
            >
          </template>
          <template v-else>
            <DrawerItem
              to="mb012"
              src="mb-charge.svg"
              class="-double"
              @click="
                trackGtmEvent(
                  '【click】グロナビ',
                  'グロナビ,お借り入れ,au PAYプリペイドカードにチャージ'
                )
              "
              >au PAY 残高にチャージ</DrawerItem
            >
          </template>
          <template v-if="isProhibitedDeposit || isProhibitedSeven || isProhibitedWakai">
            <DrawerItem
              src="mb-seven.svg"
              class="disabled"
              disabled="disabled"
              @click="
                trackGtmEvent(
                  '【click】グロナビ',
                  'グロナビ,お借り入れ,セブン銀行スマホATM'
                )
              "
              >セブン銀行スマホATM</DrawerItem
            >
          </template>
          <template v-else>
            <DrawerItem
              to="sv025"
              src="mb-seven.svg"
              target="_blank"
              @click="
                trackGtmEvent(
                  '【click】グロナビ',
                  'グロナビ,お借り入れ,セブン銀行スマホATM'
                )
              "
              >セブン銀行スマホATM</DrawerItem
            >
          </template>
          <template v-if="isProhibitedDeposit || isProhibitedSmbc || isProhibitedWakai">
            <DrawerItem
              src="mb-bank.svg"
              class="disabled"
              disabled="disabled"
              @click="
                trackGtmEvent(
                  '【click】グロナビ',
                  'グロナビ,お借り入れ,ご登録口座へのお振込み'
                )
              "
              >ご登録口座へのお振込み</DrawerItem
            >
          </template>
          <template v-else>
            <DrawerItem
              to="mb011"
              src="mb-bank.svg"
              @click="
                trackGtmEvent(
                  '【click】グロナビ',
                  'グロナビ,お借り入れ,ご登録口座へのお振込み'
                )
              "
              >ご登録口座へのお振込み</DrawerItem
            >
          </template>

          <!--<DrawerItem to="sv036" target="_blank">増枠をご希望のお客さまはこちら</DrawerItem>-->
        </DrawerList>
        <DrawerList to="mb015" nav-name="mb-return" class="-grid-2">
          <template v-if="isProhibitedWakai || isProhibitedSeven">
            <DrawerItem
              src="mb-seven.svg"
              class="disabled"
              disabled="disabled"
              @click="
                trackGtmEvent(
                  '【click】グロナビ',
                  'グロナビ,ご返済,セブン銀行スマホATM'
                )
              "
              >セブン銀行スマホATM</DrawerItem
            >
          </template>
          <template v-else>
            <DrawerItem
              to="sv029"
              src="mb-seven.svg"
              target="_blank"
              @click="
                trackGtmEvent(
                  '【click】グロナビ',
                  'グロナビ,ご返済,セブン銀行スマホATM'
                )
              "
              >セブン銀行スマホATM</DrawerItem
            >
          </template>
          <DrawerItem
            to="mb015"
            src="mb-pay.svg"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,ご返済,指定口座へのお振込み'
              )
            "
            >指定口座へのお振込み
          </DrawerItem>
          <DrawerItem to="mb052">ご返済シミュレーション</DrawerItem>
        </DrawerList>
        <DrawerList to="mb019" nav-name="mb-loan" class="-grid-2">
          <DrawerItem
            to="mb019"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,ご契約・お取引情報,ご契約内容のご確認'
              )
            "
            >ご契約内容のご確認</DrawerItem
          >
          <DrawerItem
            to="mb004"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,ご契約・お取引情報,お取引履歴のご確認'
              )
            "
            >お取引履歴のご確認</DrawerItem
          >
          <!--<DrawerItem to="sv036" target="_blank">増枠をご希望のお客さまはこちら</DrawerItem>-->
          <DrawerItem
            to="mb020"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,ご契約・お取引情報,ご契約締結書面一覧のご確認'
              )
            "
            >ご契約締結書面一覧のご確認</DrawerItem
          >
        </DrawerList>
        <DrawerList to="mb023" nav-name="mb-mypage" class="-grid-2">
          <DrawerItem
            to="mb023"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,お客さま情報,お客さま情報の確認・変更'
              )
            "
            >お客さま情報の確認・変更</DrawerItem
          >
          <DrawerItem
            to="mb021"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,お客さま情報,口座情報の登録・変更'
              )
            "
            >口座情報の登録・変更</DrawerItem
          >
          <DrawerItem
            to="mb032"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,お客さま情報,暗証番号再設定'
              )
            "
            >暗証番号再設定</DrawerItem
          >
          <DrawerItem
            to="mb026"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,お客さま情報,メールアドレス・お知らせ通知設定の変更'
              )
            "
            >メールアドレス・お知らせ通知設定の変更</DrawerItem
          >
        </DrawerList>
      </nav>
    </div>
  </header>
</template>

<script>
import {
  navMbTop,
  navMbHistory,
  navMbBorrow,
  navMbReturn,
  navMbLoan,
  navMbMypage,
  auWalletPages,
} from "@/router/index";
import {
  removeUserSessionCookie,
  initCredentials,
  authLogout,
} from "@/utils/Auth";
import { launchApp } from "@/utils/ExternalScripts";
import { isAuWallet } from "@/utils/UserAgent";
import { trackGtmEvent } from "@/utils/Gtm";

import NavList from "@/components/globals/NavList";
import NavItem from "@/components/globals/NavItem";
import DrawerList from "@/components/globals/DrawerList";
import DrawerItem from "@/components/globals/DrawerItem";
import AccordionList from "@/components/accordion/AccordionList";
import AccordionItem from "@/components/accordion/AccordionItem";

export default {
  name: "HeaderMember",
  components: {
    AccordionItem,
    AccordionList,
    NavList,
    NavItem,
    DrawerList,
    DrawerItem,
  },
  setup() {
    return {
      trackGtmEvent,
    };
  },
  data() {
    return {
      isDisabled: false,
      onMouse: "",
      menuOpen: false,
      menuOpened: false,
    };
  },
  computed: {
    isProhibitedDeposit() {
      return this.$store.getters.isProhibitedDeposit;
    },
    isProhibitedPrepaid() {
      return this.$store.getters.isProhibitedPrepaid;
    },
    isProhibitedSmbc() {
      return this.$store.getters.isProhibitedSmbc;
    },
    isProhibitedGelato() {
      return this.$store.getters.isProhibitedGelato;
    },
    isProhibitedSeven() {
      return this.$store.getters.isProhibitedSeven;
    },
    isProhibitedWakai() {
      return this.$store.getters.isProhibitedWakai;
    },
  },
  watch: {
    $route: function () {
      this.onMouse = "";
      this.menuOpen = false;
    },
  },
  methods: {
    isMbTop: function () {
      return navMbTop.indexOf(this.$route.name) !== -1;
    },
    isMbHistory: function () {
      return navMbHistory.indexOf(this.$route.name) !== -1;
    },
    isMbBorrow: function () {
      return navMbBorrow.indexOf(this.$route.name) !== -1;
    },
    isMbReturn: function () {
      return navMbReturn.indexOf(this.$route.name) !== -1;
    },
    isMbLoan: function () {
      return navMbLoan.indexOf(this.$route.name) !== -1;
    },
    isMbMypage: function () {
      return navMbMypage.indexOf(this.$route.name) !== -1;
    },
    toggleMenu: function () {
      this.menuOpen = !this.menuOpen;
    },
    afterEnter: function () {
      this.menuOpened = true;
    },
    beforeLeave: function () {
      this.menuOpened = false;
    },
    logout() {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        initCredentials()
          .then(() => {
            authLogout()
              .then(() => {
                removeUserSessionCookie();
                this.$router.push({ name: "tem024" });
              })
              .catch(() => {
                this.$router.push({ name: "SessionTimeOut" });
              });
          })
          .catch((error) => {
            this.goToErrorPage(error);
          })
          .finally(() => {
            this.isDisabled = false;
          });
      } catch (e) {
        this.goToErrorPage(e);
      }
    },
    launchApp(host) {
      launchApp(host);
    },
    isAuWallet: function () {
      return isAuWallet() && auWalletPages.indexOf(this.$route.name) !== -1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.header-member {
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
  background-color: $white;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  &.top {
    background-color: rgba($white, 0);
    border-bottom: none;
    .subnav-list {
      a {
        color: $white;
      }
    }
    .header-nav {
      > .subnav-list {
        > .menu {
          > .menutxt {
            color: $white;
          }
          > .menu-trigger span {
            background-color: $white;
          }
        }
      }
    }
  }
  @include mq-down(md) {
    padding-top: 15px;
    padding-bottom: 10px;
  }
  @include mq-up(md) {
    padding-top: 10px;
    height: 110px;
  }
  .logo {
    width: 93px;
    @include mq-up(md) {
      display: flex;
      align-items: flex-end;
      width: 189px;
    }
  }
  .header-nav {
    > .subnav-list {
      @include mq-up(md) {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 13px;
      }
      a {
        font-size: 10px;
        padding: 7px 10px 0;
        display: inline-block;
        line-height: 14px;
        text-align: center;
        @include mq-up(md) {
          font-size: 12px;
          padding: 10px 10px 0;
          line-height: 16px;
          min-width: 80px;
          min-height: 36px;
        }
      }
      > .application,
      .login,
      .logout {
        @include mq-down(md) {
          display: inline-block;
          float: left;
          margin-top: 2px;
        }
        a {
          color: $white;
        }
      }
      > .application {
        background-color: $primary;
        border-radius: 6px;
        margin-right: 2px;
      }
      > .login {
        background-color: $white;
        border: 1px solid $secondary;
        border-radius: 6px;
        > a {
          color: $primary;
        }
      }
      > .logout {
        border: 1px solid $secondary;
        border-radius: 6px;
        background-color: #fff;
        > a {
          color: $primary;
          padding: 7px 0 0;
          min-width: 63px;
          min-height: 27px;
          @include mq-up(md) {
            padding: 10px 0 0;
            min-width: 78px;
            min-height: 34px;
          }
        }
        > .-logout {
          color: $primary;
          padding: 7px 0 0;
          min-width: 63px;
          min-height: 27px;
          font-size: 10px;
          line-height: 14px;
          text-align: center;
          @include mq-down(md) {
            display: inline-block;
          }
          @include mq-up(md) {
            padding: 10px 0 0;
            min-width: 78px;
            min-height: 34px;
            font-size: 12px;
            line-height: 16px;
          }
        }
        @include mq-up(md) {
          margin-left: 10px;
        }
      }
      > .menu {
        float: left;
        width: 30px;
        margin-left: 20px;
        > .menutxt {
          font-size: 10px;
          margin-bottom: 0;
          line-height: 18px;
        }
        > .menu-trigger,
        > .menu-trigger span {
          display: inline-block;
          transition: all 0.4s;
          box-sizing: border-box;
        }
        > .menu-trigger {
          position: relative;
          width: 24px;
          height: 18px;
          margin-left: 3px;
          > span {
            position: absolute;
            left: 0;
            width: 100%;
            height: 2px;
            background-color: $gray;
            border-radius: 4px;
          }
        }
        .top & {
          > .menutxt {
            color: $white;
          }
        }
        > .menu-trigger span:nth-of-type(1) {
          top: 0;
        }
        > .menu-trigger span:nth-of-type(2) {
          top: 8px;
        }
        > .menu-trigger span:nth-of-type(3) {
          bottom: 0;
        }
        > .menu-trigger.active span:nth-of-type(1) {
          -webkit-transform: translateY(8px) rotate(-45deg);
          transform: translateY(8px) rotate(-45deg);
        }
        > .menu-trigger.active span:nth-of-type(2) {
          opacity: 0;
        }
        > .menu-trigger.active span:nth-of-type(3) {
          -webkit-transform: translateY(-8px) rotate(45deg);
          transform: translateY(-8px) rotate(45deg);
        }
      }
    }
    > .spmenu {
      &.slide-enter,
      &.slide-leave-to {
        left: 100%;
      }
      &.slide-enter-to,
      &.slide-leave {
        left: 20%;
      }
      &.slide-enter-active,
      &.slide-leave-active {
        transition: left 0.3s ease;
      }
      position: fixed;
      top: 65px;
      z-index: 9998;
      width: 80%;
      height: calc(100% - 65px);
      overflow-y: auto;
      padding-bottom: 50px;
      &.show {
        left: 20%;
      }
      > .entry {
        padding: 15px;
        background-color: $success;
      }
      > .btn {
        width: 100%;
        height: 56px;
        display: flex;
        background-color: $white;
        > .atag {
          display: flex;
          height: 100%;
          line-height: 100%;
          justify-content: center;
          align-items: center;
          > .txt {
            > .img {
              width: 20px;
              height: auto;
              margin-right: 5px;
              vertical-align: middle;
            }
          }
        }
        &.qa {
          border-bottom: 1px solid $secondary;
          > .atag {
            width: 50%;
            font-size: 12px;
            &:nth-last-of-type(1) {
              border-left: 1px solid $secondary;
            }
          }
        }
        &.close {
          > .atag {
            width: 100%;
            > .txt {
              > .img {
                width: 15px;
                margin-right: 10px;
                vertical-align: top;
              }
            }
          }
        }
      }
    }
    .overlay {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 65px;
      left: 0;
      z-index: 9997;
      background-color: rgba($black, 0.4);
      transition: all 300ms ease;
      opacity: 0;
      visibility: hidden;
      &.show {
        opacity: 1;
        visibility: visible;
      }
    }
  }
}
</style>
